import styled from 'styled-components'

const ContentWrapper = styled.div`
  backdrop-filter: blur(16px) brightness(0.7) contrast(1.2);
`
export default ContentWrapper
